import { useMemo } from 'react';
import { useBiLogger } from '@wix/cli-telemetry-react';
import { wixCliAstroBiEvents } from './events.js';

export function useWixCliAstroBi() {
  const biLogger = useBiLogger();
  return useMemo(() => wixCliAstroBiEvents(biLogger), [biLogger]);
}
